module.exports = __webpack_public_path__ + "files/e13e5ba5d6bc1ea9b557b053ab49763d.svg";